import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from './store';

import ParametersChooserPage from './pages/ParametersChooserPage/ParametersChooserPage';
import VisualChooserPage from './pages/VisualChooserPage/VisualChooserPage';

const initChooser = () => {
	const domNode = document.getElementById( 'chooser' );

	if ( !domNode )
	{
		return;
	}

	const chooserType = domNode.classList.contains( 'visual' );
	
	const root = createRoot(domNode);
	root.render(
		<Provider store={store}>
			{
				chooserType
				? <VisualChooserPage />
				: <ParametersChooserPage />
			}
		</Provider>
	);
};

export {
	initChooser,
};
